/**
 * @namespace layout/navigation/sidebar
 */
import { MENU_ITEM } from '~/utils/lib/layout/types'

export type SIDEBAR_VIEW = typeof SIDEBAR_VIEW[keyof typeof SIDEBAR_VIEW]
export const SIDEBAR_VIEW = {
  SERVICE: 'sidebar_view_service',
  PARAMETERS: 'sidebar_view_parameters',
} as const

export const useStore_layout_navigation_sidebar = defineStore('layout/navigation/sidebar', {
  state: () => ({
    sidebarView: SIDEBAR_VIEW.SERVICE as SIDEBAR_VIEW,
    menuItem: MENU_ITEM.DASHBOARD as MENU_ITEM,
  }),
  actions: {
    /// Mutations
    ///
    setSidebarView(view: SIDEBAR_VIEW) {
      this.sidebarView = view
    },
    setMenuItem(item: MENU_ITEM) {
      this.menuItem = item
    },
  },
})
